<template>
  <div>
    <b-modal ref="timeFrameModal" @ok="scheduleItemUpdated">
      <div v-if="scheduleItem && provider">
        <b>Time Information</b>
        <br />
        <b
          ><div class="text-muted pt-4">{{ provider.name }}</div></b
        >

        <div class="timeSelectWrapper pt-2">
          <TimeSelection v-model="startDate" />
          <span class="pt-1">-</span>

          <TimeSelection v-model="endDate" />
        </div>
        <br />
        <b>Apply To</b><br />

        <ul>
          <li
            v-bind:class="{ daySelected: hasDay(0) }"
            @click.prevent="toggleDay(0)"
          >
            S
          </li>
          <li
            v-bind:class="{ daySelected: hasDay(1) }"
            @click.prevent="toggleDay(1)"
          >
            M
          </li>
          <li
            v-bind:class="{ daySelected: hasDay(2) }"
            @click.prevent="toggleDay(2)"
          >
            T
          </li>
          <li
            v-bind:class="{ daySelected: hasDay(3) }"
            @click.prevent="toggleDay(3)"
          >
            W
          </li>
          <li
            v-bind:class="{ daySelected: hasDay(4) }"
            @click.prevent="toggleDay(4)"
          >
            T
          </li>
          <li
            v-bind:class="{ daySelected: hasDay(5) }"
            @click.prevent="toggleDay(5)"
          >
            F
          </li>
          <li
            v-bind:class="{ daySelected: hasDay(6) }"
            @click.prevent="toggleDay(6)"
          >
            S
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TimeSelection from "@/views/Components/Schedule/TimeSelection.vue";
export default {
  components: { TimeSelection },
  props: { scheduleItem: null, providers: null },
  watch: {
    scheduleItem(newVal) {
      if (newVal) {
        this.daysSelected = [];
        this.$refs.timeFrameModal.show();
        this.provider = this.scheduleItem.provider;
        this.daysSelected.push(this.scheduleItem.startDate.getDay());
        this.startDate = this.scheduleItem.startDate;
        this.endDate = this.scheduleItem.endDate;
      } else this.$refs.timeFrameModal.hide();
    },
  },
  created() {},
  data() {
    return {
      startDate: null,
      endDate: null,
      daysSelected: [],
      provider: null,
    };
  },
  methods: {
    scheduleItemUpdated() {
      this.$emit("scheduleItemUpdated", {
        guid: this.scheduleItem.guid,
        providerId: this.provider.id,
        days: this.daysSelected,
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    toggleDay(d) {
      if (this.hasDay(d)) {
        this.daysSelected.splice(this.daysSelected.indexOf(d), 1);
      } else {
        this.daysSelected.push(d);
      }
    },
    hasDay(d) {
      return this.daysSelected.find((f) => f == d) != undefined;
    },
  },
};
</script>

<style scoped>
.timeSelectWrapper {
  display: grid;
  grid-template-columns: 1fr 25px 1fr;
  text-align: center;
  grid-gap: 1px;
}
li {
  float: left;
  padding-right: 5px;
  border-radius: 50%;
  margin-right: 5px;
  text-align: center;
  padding-top: 14px;
  padding-right: 2px;
  height: 50px;
  cursor: pointer;
  width: 50px;
}

li:hover {
  background-color: #eee;
}
.daySelected {
  background-color: #579dd2;
  color: white;
}

.daySelected:hover {
  background-color: #579dd2;
  color: white;
}
ul {
  margin-top: 10px;
  margin-left: 0;
  padding: 0;
  list-style-type: none;
}

.timeSelectWrapper > div {
  text-align: center;
}
</style>
